import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AppSection from '@/pages/home/components/AppSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <AppSection />
        <CarouselSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesSection />
        <AboutSection />
        <TopicsSection />
        <FaqSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}